import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import EmptyStates from '../../../app/components/empty-states';
import withTranslate from '../../../app/hoc/with-translate';
import withLayoutProps from '../../hoc/with-layout-props';

const NoPosts = ({ t, isLayoutTextOnImage, ...props }) => {
  return (
    <EmptyStates
      title={t('no-posts-feed.on-the-way')}
      content={t('no-posts-feed.stay-tuned')}
      isLayoutTextOnImage={isLayoutTextOnImage}
      {...props}
    />
  );
};

NoPosts.propTypes = {
  t: PropTypes.func,
  isLayoutTextOnImage: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

export default flowRight(withTranslate, withLayoutProps)(NoPosts);
